'use client';

import dynamic from 'next/dynamic';

// Dynamic import with SSR disabled to prevent hydration errors
// @polkadot/react-identicon uses browser-only APIs
const Identicon = dynamic(() => import('@polkadot/react-identicon').then((mod) => mod.Identicon), {
	ssr: false,
	loading: () => (
		<span
			className='bg-secondary inline-block animate-pulse rounded-full'
			style={{ width: 24, height: 24 }}
		/>
	)
});

interface AddressIdenticonProps {
	/** SS58 address to generate identicon for */
	address: string;
	/** Size of the identicon in pixels (default: 24) */
	size?: number;
	/** Additional CSS class names */
	className?: string;
	/** Identicon theme (default: polkadot) */
	theme?: 'polkadot' | 'substrate' | 'beachball' | 'jdenticon';
}

/**
 * Renders a Polkadot-style identicon for an SS58 address.
 * Uses SSR-disabled dynamic import to prevent hydration issues in Next.js.
 */
function AddressIdenticon({ address, size = 24, className = '', theme = 'polkadot' }: AddressIdenticonProps) {
	return (
		<span className={`inline-flex items-center justify-center align-middle ${className}`}>
			<Identicon
				value={address}
				size={size}
				theme={theme}
			/>
		</span>
	);
}

export default AddressIdenticon;
